import { Injectable } from "@angular/core";
import { CanActivate, Router } from "@angular/router";

@Injectable({
  providedIn: "root",
})
export class LoginAuthGuard implements CanActivate {
  constructor(private router: Router) {}

  canActivate(): boolean {
    const userStatus = localStorage.getItem("loginStatus");
    if (
      userStatus == "yes" &&
      (localStorage.getItem("role") == "OEM" ||
        localStorage.getItem("role") == "ADMIN" ||
        localStorage.getItem("role") == "USER" ||
        localStorage.getItem("role") == "CLIENT")
    ) {
      return false;
    } else {
      return true;
    }
  }
}
